<dx-toolbar [ngClass]="{'toolbar': true, 'drawer-toolbar': isInDrawer}">
  <dxi-item location="before" widget="dxTextBox">
    <dx-button stylingMode="outlined" icon="taskinprogress" [disabled]="true"> </dx-button>
  </dxi-item>
  <dxi-item
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style=" padding-inline: 10px"
  >Form
  </dxi-item>
  <dxi-item
    *ngIf="formName"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-inline: 1px solid; padding-inline: 10px"
  >{{this.getFormName(formName) +'/Detay'}}
  </dxi-item>
  <dxi-item
    *ngIf="formAction"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-right: 1px solid; padding-inline: 10px"
  >{{formAction}}
  </dxi-item>
  <dxi-item
    *ngIf="auditInfo"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-inline: 1px solid; padding-inline: 10px; white-space: nowrap; font-weight: bold; color: #0a1a4a;"
  >Oluşturan: {{ auditInfo.kayitKullaniciAd || '-' }} ({{ (auditInfo.kayitTarih | date:'dd.MM.yyyy HH:mm') || '-' }}) | Güncelleyen: {{ auditInfo.degisKullaniciAd || '-' }} ({{ (auditInfo.degisTarih | date:'dd.MM.yyyy HH:mm') || '-' }})
  </dxi-item>

  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="toastMessageButtonOptions"
  >
  </dxi-item>
  <dxi-item *ngIf="this.state !== 'New' && (this.historyEntityName || this.effectiveEntityData?.kayitAdi)"
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="histyoryButtonOptions"
  >
  </dxi-item>
  <!-- DKM-1078 Cedric: liste footer'daki gibi "Yardım → Destek Talebi Aç" -->
  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="helpButtonOptions"
  >
  </dxi-item>
  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="infoButtonOptions"
  >
  </dxi-item>


</dx-toolbar>

<ng-container *ngIf="historyPopupVisible">
  <dx-popup
    height="82%"
    width="80%"
    [showTitle]="true"
    [position]="'center'"
    [title]="'İşlem Geçmişi'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="historyPopupVisible"
  >
    <dk-history [entityName]="historyEntityName || effectiveEntityData?.kayitAdi" [selectedRowData]="effectiveEntityData"></dk-history>
  </dx-popup>
</ng-container>

<!-- DKM-1078 Cedric: Destek Talebi Aç (dk-list-footer ile aynı popup) -->
<ng-container *ngIf="helpPopupVisible">
  <dk-form-popup
    [popupName]="'DestekTalepForm'"
    [state]="'New'"
    [width]="'40%'"
    [visible]="helpPopupVisible"
    (visibleChange)="helpPopupVisible = $event"
    [title]="'Destek Talebi Aç'"
  >
    <dk-dk-list-help-form
      [formCode]="formName"
      [recordData]="recordData"
      (closePopup)="helpPopupVisible = false"
    ></dk-dk-list-help-form>
  </dk-form-popup>
</ng-container>
